<template>
    <div>
        <div class="hint" v-if="store.state.hintIsShow">{{store.state.hintmsg}}</div>
        
    </div>
</template>

<script>
export default {
  name: "hint",
  data() {
    return {
      msg: "提示信息"
    };
  }
};
</script>

<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition: all 0.7s;
  transform: translateY(0);
  font-size: 20px;
}
.fade-enter,
.fade-leave-to {
  transform: translateY(-100%);
}
.hint {
  font-size: 1.2rem;
  position: fixed;
  color: #fff;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background: rgba(0, 0, 0, 0.6);
  padding: 0.3rem 1rem;
  border-radius: 0.2rem;
  text-align: center;
  z-index: 9999999999999;
}
</style>



// WEBPACK FOOTER //
// src/components/component/hint.vue